<template>
  <div>
    <div
      v-if="modalOpened && modalType.status === 'success'"
      class="fixed z-60 top-[130px] right-[20px] sm:right-[40px]"
    >
      <div
        ref="modal"
        class="w-[330px] duration-800 overflow-hidden rounded-[10px] box-effect"
      >
        <!-- actual modal -->
        <div
          class="mx-auto rounded flex flex-col gap-[8px] p-[16px] pt-[12px] overflow-hidden bg-[#F2FCE9]"
        >
          <div class="flex items-start gap-[10px]">
            <CheckTickIcon
              :bg="'#95E648'"
              class="text-[#F7F9FD] min-w-[24px] min-h-[24px] w-[24px] h-[24px] mt-[2px] p-[2px]"
            />
            <div class="flex flex-col items-start text-[#3B5C1C]">
              <div
                v-if="modalType.status === 'success'"
                class="PC_H3-SB min-h-[35px]"
              >
                {{ modalInfo.header || "ดำเนินการสำเร็จ !" }}
              </div>
              <div class="PC_Body2-R mt-[-1.4px] whitespace-pre-line">
                {{
                  modalInfo.subHeader?.replace(/\\n/g, "\n") ||
                  "จะไม่สามารถเรียกคืนข้อมูลได้ ท่านต้องการลบข้อมูลหรือไม่"
                }}
              </div>
            </div>
          </div>
          <div class="flex justify-end gap-[10px]">
            <button
              class="btn-secondary ButtonS min-w-[93px]"
              @click="handleClose"
            >
              {{ modalInfo.closeButtonText || "ปิดหน้าต่าง" }}
            </button>
            <button
              v-if="modalInfo.submitButtonText"
              class="btn-warning ButtonS min-w-[93px] !text-[#3A2C11]"
              :class="modalInfo.widthWarning"
              @click="$emit('submit', modalItem), closeModal()"
            >
              {{ modalInfo.submitButtonText }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="modalOpened && modalType.status != 'success'"
      class="fixed inset-0 w-full z-60 duration-100 bg-black/30"
    >
      <div
        class="fixed inset-0 overflow-hidden flex items-start justify-center py-8"
      >
        <div
          ref="modal"
          class="w-[330px] duration-800 overflow-hidden rounded-[10px] box-effect m-auto"
        >
          <!-- actual modal -->
          <div
            v-if="modalType.status"
            class="mx-auto rounded flex flex-col gap-[8px] p-[16px] pt-[12px] overflow-hidden"
            :class="[
              {
                'bg-[#F2FCE9]': modalType.status === 'success',
                'bg-[#FCF6E8]': modalType.status === 'warning',
                'bg-[#FCE8E7]': modalType.status === 'error',
              },
            ]"
          >
            <div class="flex items-start gap-[10px]">
              <CheckTickIcon
                v-if="modalType.status === 'success'"
                :bg="'#95E648'"
                class="text-[#F7F9FD] min-w-[24px] min-h-[24px] w-[24px] h-[24px] mt-[2px] p-[2px]"
              />
              <!-- warning icon -->
              <svg
                v-if="modalType.status === 'warning'"
                class="min-w-[24px] min-h-[24px] w-[24px] h-[24px] mt-[2px] p-[1.5px]"
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 18 18"
                fill="none"
              >
                <path
                  d="M14.8923 3.10728C11.6379 -0.146743 6.36141 -0.147106 3.10667 3.10728C-0.147716 6.36166 -0.147354 11.6382 3.10667 14.8929C6.36105 18.1466 11.6376 18.1469 14.8923 14.8929C18.1463 11.6382 18.146 6.36202 14.8923 3.10728ZM10.0861 12.6233C10.0861 13.2237 9.59949 13.7103 8.99912 13.7103C8.39875 13.7103 7.91216 13.2237 7.91216 12.6233V8.27545C7.91216 7.67508 8.39875 7.18848 8.99912 7.18848C9.59949 7.18848 10.0861 7.67508 10.0861 8.27545V12.6233ZM8.97992 6.41746C8.35383 6.41746 7.93643 5.97398 7.94947 5.42651C7.93643 4.85259 8.35383 4.42251 8.9926 4.42251C9.63174 4.42251 10.0361 4.85295 10.0495 5.42651C10.0491 5.97398 9.6321 6.41746 8.97992 6.41746Z"
                  fill="#EBB854"
                />
              </svg>
              <!-- error icon -->
              <ErrorIcon
                v-if="modalType.status === 'error'"
                class="min-w-[24px] min-h-[24px] w-[24px] h-[24px] mt-[2px] p-[2px]"
              />
              <div
                class="flex flex-col items-start"
                :class="[
                  {
                    'text-[#3B5C1C]': modalType.status === 'success',
                    'text-[#A4803B]': modalType.status === 'warning',
                    'text-[#A33B3B]': modalType.status === 'error',
                  },
                ]"
              >
                <div
                  v-if="modalType.status === 'success'"
                  class="PC_H3-SB min-h-[35px]"
                >
                  {{ modalInfo.header || "ดำเนินการสำเร็จ !" }}
                </div>
                <div
                  v-if="modalType.status === 'warning'"
                  class="PC_H3-SB min-h-[35px]"
                >
                  {{ modalInfo.header || "คำเตือน !" }}
                </div>
                <div
                  v-if="modalType.status === 'error'"
                  class="PC_H3-SB min-h-[35px]"
                >
                  {{ modalInfo.header || "เกิดความผิดพลาด !" }}
                </div>
                <div v-if="modalInfo.names?.length > 0">
                  <ul class="mb-5">
                    <li
                      class="text-sm"
                      v-for="name in modalInfo.names"
                      :key="name.firstname + name.lastname"
                    >
                      {{ name.prefix_name }} {{ name.first_name }}
                      {{ name.lname_name }}
                    </li>
                  </ul>
                </div>
                <div class="PC_Body2-R mt-[-1.4px] whitespace-pre-line">
                  {{
                    modalInfo.subHeader?.replace(/\\n/g, "\n") ||
                    "จะไม่สามารถเรียกคืนข้อมูลได้ ท่านต้องการลบข้อมูลหรือไม่"
                  }}
                </div>
              </div>
            </div>
            <div class="flex justify-end gap-[10px]">
              <button
                class="btn-secondary ButtonS min-w-[93px]"
                @click="handleClose"
              >
                {{ modalInfo.closeButtonText || "ปิดหน้าต่าง" }}
              </button>
              <button
                v-if="modalInfo.submitButtonText"
                class="btn-warning ButtonS min-w-[93px] !text-[#3A2C11] px-4"
                :class="modalInfo.widthWarning"
                @click="handleSubmit(modalItem)"
              >
                {{ modalInfo.submitButtonText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from "vue";
const props = defineProps({
  status: {
    type: String,
    default: "",
  },
});
const modalType = ref({
  status: props.status,
});
const modalInfo = ref({
  header: "",
  names: [],
  subHeader: "",
  closeButtonText: "",
  submitButtonText: "",
  timeout: "",
  widthWarning: "",
});
const modalItem = ref("");
const modalOpened = ref(false);
const modal = ref("");

let timeoutId = null;

const emit = defineEmits(["confirm", "closeAndGo", "close", "submit"]);

const openModal = (status, passedModalInfo, data) => {
  console.log(passedModalInfo);
  if (timeoutId) {
    clearTimeout(timeoutId);
    timeoutId = null;
  }

  modalType.value.status = status;
  modalOpened.value = true;
  modalInfo.value = passedModalInfo;
  // data for remove or delete
  modalItem.value = data;
  if (modalType.value.status != "success") {
    document.body.style.overflow = "hidden";
  }
  if (modalInfo.value.timeout) {
    timeoutId = setTimeout(() => {
      closeModal();
      timeoutId = null;
    }, modalInfo.value.timeout);
  }
  // if (modalType.value.status == "success") {
  //   setTimeout(() => {
  //     closeModal();
  //   }, 3000);
  // }
};

const closeModal = () => {
  if (timeoutId) {
    clearTimeout(timeoutId);
    timeoutId = null;
  }
  if (modalType.value.status === "success") {
    emit("close", modalItem);
  }
  modalOpened.value = false;
  document.body.style.overflow = "auto";
};

const handleClose = () => {
  emit("close", modalItem);
  typeof modalInfo.value.onClose === "function"
    ? modalInfo.value.onClose()
    : "";
  closeModal();
};

const handleSubmit = (modalItem) => {
  console.log("tryAgain", modalItem);
  emit("submit", modalItem);
  emit("tryAgain");
  if (typeof modalInfo.value.onSubmit === "function") {
    modalInfo.value.onSubmit();
  }
  closeModal();
};

onMounted(() => {
  // openModal("success",)
});

defineExpose({ openModal });
</script>

<style lang="scss" scoped>
.ButtonS {
  color: #1f1d1f;
  /* Button/s */
  font-family: Kanit;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  /* 153.846% */
  letter-spacing: 0.1px;
}
</style>
